import React from 'react';

const Footer = () => {
  return <wp-footer></wp-footer>;
};

export default Footer;
